import React from 'react';

// Empty-state mark for Performance: a gradient bar chart inside the shared
// gradient-bordered tile. Rendered at its native 80px (drawn in an 80x80
// viewBox); the frame is part of the artwork (the outer <rect>). Gradient ids are
// per-instance (useId) so multiple copies on a page don't collide.
const NoPerformanceIcon = ({ size = 80 }) => {
  const uid = React.useId();
  const g = (n) => `no_performance_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="79" height="79" rx="11.5" stroke={`url(#${g(0)})`} />
      <rect x="19" y="33" width="9" height="23" rx="2" fill={`url(#${g(1)})`} />
      <rect x="35" y="23" width="9" height="33" rx="2" fill={`url(#${g(2)})`} />
      <rect x="51" y="28" width="9" height="28" rx="2" fill={`url(#${g(3)})`} />
      <path
        d="M19 56L60 56"
        stroke={`url(#${g(4)})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={g(0)} x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7853F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(1)} x1="16.75" y1="38.75" x2="32.3598" y2="44.8582" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(2)} x1="32.75" y1="31.25" x2="49.5038" y2="35.8192" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(3)} x1="48.75" y1="35" x2="65.0645" y2="40.2439" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(4)} x1="8.75" y1="56.25" x2="8.79875" y2="58.2488" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoPerformanceIcon;
